import React from "react";
import { Route, Routes } from "react-router-dom";

import ROUTES_NAVIGATION from "./routes";

import AddProduct from "../components/DealerManagement/Admin/ProductManagement/ProductList/AddProduct";
import AddSubProduct from "../components/DealerManagement/Admin/ProductManagement/SubProductList/AddSubProduct";
import ProductList from "../components/DealerManagement/Admin/ProductManagement/ProductList";
import SubProductList from "../components/DealerManagement/Admin/ProductManagement/SubProductList";
import ProductColorList from "../components/DealerManagement/Admin/ProductManagement/ProductColorList";
import AddProductColor from "../components/DealerManagement/Admin/ProductManagement/ProductColorList/AddProductColor";
import ProductFuelTypeList from "../components/DealerManagement/Admin/ProductManagement/ProductFuelTypeList";
import AddProductFuelType from "../components/DealerManagement/Admin/ProductManagement/ProductFuelTypeList/AddProductFuelType";
import MakeList from "../components/DealerManagement/Admin/ProductManagement/ProductMakeList";
import AddMake from "../components/DealerManagement/Admin/ProductManagement/ProductMakeList/AddProductMake";
import ModelList from "../components/DealerManagement/Admin/ProductManagement/ProductModelList";
import AddModel from "../components/DealerManagement/Admin/ProductManagement/ProductModelList/AddProductModel";
import VariantList from "../components/DealerManagement/Admin/ProductManagement/ProductVariantList";
import AddVariant from "../components/DealerManagement/Admin/ProductManagement/ProductVariantList/AddProductVariant";
import SpecificationList from "../components/DealerManagement/Admin/ProductManagement/ProductSpecificationList";
import AddSpecification from "../components/DealerManagement/Admin/ProductManagement/ProductSpecificationList/AddProductSpecification";
import ItemList from "../components/DealerManagement/Admin/ProductManagement/ProductItemList";
import AddItem from "../components/DealerManagement/Admin/ProductManagement/ProductItemList/AddProductItem";
import FinancierList from "../components/DealerManagement/Admin/ProductManagement/ProductFinancierList";
import AddFinancier from "../components/DealerManagement/Admin/ProductManagement/ProductFinancierList/AddProductFinancier";
import EditProduct from "../components/DealerManagement/Admin/ProductManagement/ProductList/EditProduct";
import EditSubProduct from "../components/DealerManagement/Admin/ProductManagement/SubProductList/EditSubProduct";
import EditProductColor from "../components/DealerManagement/Admin/ProductManagement/ProductColorList/EditProductColor";
import EditProductFinancier from "../components/DealerManagement/Admin/ProductManagement/ProductFinancierList/EditProductFinancier";
import EditProductFuelType from "../components/DealerManagement/Admin/ProductManagement/ProductFuelTypeList/EditProductFuelType";
import EditMake from "../components/DealerManagement/Admin/ProductManagement/ProductMakeList/EditProductMake";
import EditModel from "../components/DealerManagement/Admin/ProductManagement/ProductModelList/EditProductModel";
import EditVariant from "../components/DealerManagement/Admin/ProductManagement/ProductVariantList/EditProductVariant";
import EditItem from "../components/DealerManagement/Admin/ProductManagement/ProductItemList/AddProductItem/EditProductItem";
import DiscountList from "../components/DealerManagement/Admin/ProductManagement/ProductDiscountList";
import AddDiscount from "../components/DealerManagement/Admin/ProductManagement/ProductDiscountList/AddProductDiscount";
import EditDiscount from "../components/DealerManagement/Admin/ProductManagement/ProductDiscountList/EditProductDiscount";
import SeatingCapacity from "../components/DealerManagement/Admin/LogisticsManagement/SeatingCapacity";
import AddSeatingCapacity from "../components/DealerManagement/Admin/LogisticsManagement/SeatingCapacity/AddSeatingCapacity";
import EditSeatingCapacity from "../components/DealerManagement/Admin/LogisticsManagement/SeatingCapacity/EditSeatingCapacity";
import Wheels from "../components/DealerManagement/Admin/LogisticsManagement/Wheels";
import AddWheels from "../components/DealerManagement/Admin/LogisticsManagement/Wheels/AddWheels";
import EditWheels from "../components/DealerManagement/Admin/LogisticsManagement/Wheels/EditWheels";
import ItemCategoryList from "../components/DealerManagement/Admin/ProductManagement/ProductItemCategory";
import AddItemCategory from "../components/DealerManagement/Admin/ProductManagement/ProductItemCategory/AddProductItemCategory";
import EditItemCategory from "../components/DealerManagement/Admin/ProductManagement/ProductItemCategory/EditProductItemCategory";
import BatteryList from "../components/DealerManagement/Admin/ProductManagement/BatteryList";
import AddBatery from "../components/DealerManagement/Admin/ProductManagement/BatteryList/AddBattery";
import EditBattery from "../components/DealerManagement/Admin/ProductManagement/BatteryList/EditBattery";
import StockIn from "../components/DealerManagement/Admin/ProductManagement/StockIn";
import AddStockIn from "../components/DealerManagement/Admin/ProductManagement/StockIn/AddStockIn";
import StockInReportAdmin from "../components/DealerManagement/Admin/ProductManagement/StockInReportAdmin";
import DailyStockUpload from "../components/DealerManagement/Admin/ProductManagement/DailyStockUpdate";

const ProductRoutes = () => {
  return (
    <>
      <Route
        path={ROUTES_NAVIGATION.ADDPRODUCT}
        element={<AddProduct />}
      />
       <Route
        path={ROUTES_NAVIGATION.EDITPRODUCT}
        element={<EditProduct />}
      />

       <Route
        path={ROUTES_NAVIGATION.DAILYSTOCKUPDATE}
        element={<DailyStockUpload />}
      />

      <Route
        path={ROUTES_NAVIGATION.ADDSUBPRODUCT}
        element={<AddSubProduct />}
        
      />
        <Route
        path={ROUTES_NAVIGATION.EDITSUBPRODUCT}
        element={<EditSubProduct />}
      />
       <Route path={ROUTES_NAVIGATION.PRODUCTCOLORLIST} element={<ProductColorList />} />
      <Route
        path="admin/manage-product/color/add-product-color"
        element={<AddProductColor />}
        
      />
       <Route
        path={ROUTES_NAVIGATION.EDITPRODUCTCOLOR  }
        element={<EditProductColor />}
        
      />

<Route path={ROUTES_NAVIGATION.PRODUCTFUELTYPELIST} element={<ProductFuelTypeList />} />
      <Route
        path="admin/manage-product/fuel-type/add-fuel-type"
        element={<AddProductFuelType />}
        
      />
      <Route
        path={ROUTES_NAVIGATION.EDITPRODUCTFUELTYPE}
        element={<EditProductFuelType />}
        
      />
      <Route path={ROUTES_NAVIGATION.MAKELIST} element={<MakeList />} />
      <Route
        path="admin/manage-product/make/add-make"
        element={<AddMake />}
        
      />
        <Route
        path={ROUTES_NAVIGATION.EDITMAKE}
        element={<EditMake />}
        
      />
       <Route path={ROUTES_NAVIGATION.MODELLIST} element={<ModelList />} />
      <Route
        path="admin/manage-product/model/add-model"
        element={<AddModel />}
        
      />
        <Route
        path={ROUTES_NAVIGATION.EDITMODEL}
        element={<EditModel />}
        
      />

<Route path="admin/manage-product/variant" element={<VariantList />} />
      <Route
        path="admin/manage-product/variant/add-variant"
        element={<AddVariant />}
        
      />
       <Route
        path={ROUTES_NAVIGATION.EDITVARIANT}
        element={<EditVariant />}
        
      />
      
      <Route path="admin/manage-product/specification" element={<SpecificationList />} />
      <Route
        path="admin/manage-product/specification/add-specification"
        element={<AddSpecification />}
        
      />
      <Route path="admin/manage-product/item" element={<ItemList />} />
      <Route
        path="admin/manage-product/item/add-item"
        element={<AddItem />}
        
      />
       <Route
        path={ROUTES_NAVIGATION.EDITITEM}
        element={<EditItem />}
        
        
      />

      <Route 
      path={ROUTES_NAVIGATION.PRODUCTITEMCATEGORY}
      element={ <ItemCategoryList/> }
      />

<Route 
      path={ROUTES_NAVIGATION.ADDPRODUCTITEMCATEGORY}
      element={ <AddItemCategory/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.EDITPRODUCTITEMCATEGORY}
      element={ <EditItemCategory/> }
      />

       <Route path={ROUTES_NAVIGATION.PRODUCTFINANCIERLIST} element={<FinancierList />} />
      <Route
        path="admin/manage-product/financier/add-financier"
        element={<AddFinancier />}
        
      />
       <Route
        path={ROUTES_NAVIGATION.EDITPRODUCTFINANCIER}
        element={<EditProductFinancier />}
        
      />
      <Route path={ROUTES_NAVIGATION.PRODUCTLIST} element={<ProductList />} />
      <Route path={ROUTES_NAVIGATION.SUBPRODUCTLIST} element={<SubProductList />} />

      <Route 
      path={ROUTES_NAVIGATION.DISCOUNTLIST}
      element={ <DiscountList/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.ADDDISCOUNTLIST}
      element={ <AddDiscount/> }
      />

      <Route 
      path={ROUTES_NAVIGATION.EDITDISCOUNTLIST}
      element={ <EditDiscount/> }
      />
        <Route 
      path={ROUTES_NAVIGATION.SEATINGCAPACITYLIST}
      element={ <SeatingCapacity/> }
      />
        <Route 
      path={ROUTES_NAVIGATION.SEATINGCAPACITYADD}
      element={ <AddSeatingCapacity /> }
      />
        <Route 
      path={ROUTES_NAVIGATION.SEATINGCAPACITYEDIT}
      element={ <EditSeatingCapacity /> }
      />
         <Route 
      path={ROUTES_NAVIGATION.WHEELLIST}
      element={ <Wheels /> }
      />
       <Route 
      path={ROUTES_NAVIGATION.WHEELSADD}
      element={ <AddWheels /> }
      />
        <Route 
      path={ROUTES_NAVIGATION.WHEELSEDIT}
      element={ <EditWheels /> }
      />

      <Route 
       path={ROUTES_NAVIGATION.BATTERYLIST}
      element={ <BatteryList /> }
      />

      <Route 
       path={ROUTES_NAVIGATION.ADDBATTERY}
      element={ <AddBatery /> }
      />

      <Route 
       path={ROUTES_NAVIGATION.EDITBATTERY}
      element={ <EditBattery /> }
      />

       <Route 
       path={ROUTES_NAVIGATION.STOCKINADMIN}
      element={ <StockIn /> }
      />
      <Route 
       path={ROUTES_NAVIGATION.ADDSTOCKINADMIN}
      element={ <AddStockIn /> }
      />

      <Route 
       path={ROUTES_NAVIGATION.ADMINSTOCKINREPORT}
      element={ <StockInReportAdmin /> }
      />

    </>
  );
};

export default ProductRoutes;
